module.exports = __webpack_public_path__ + "img/kiosk-inventory-shopping-mall.21226f55.jpg";